import React, { useEffect, useRef } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import * as vars from '../style/vars'
import { above, below } from '../style/functions'
import rightCircle from '../svg/right-circle.svg'
import { RichText } from 'prismic-reactjs';

const Contact = ({ people, bg, hours, message }) => {
	const countdownRef = useRef(null);

	useEffect(() => {
		//   const openingSeconds = {
		//     wdyOpenSec: 43200,
		//     wenOpenSec: 39600,
		//     wdyCloseSec: 64800,
		//     wenCloseSec: 61200,
		//   }; // Hours * 3600

		const openingSeconds = {
			wdyOpenSec: 15 * 3600,
			wdyCloseSec: 18 * 3600,
			wenOpenSec: 12 * 3600,
			wenCloseSec: 16 * 3600,
		} // 24 hours * 3600

		const getTodaysDay = () => {
			let today = new Date()
			// today = today.toLocaleString("en-AU", {
			//    timeZone: "Australia/Melbourne"
			// })
			// today = new Date(today)
			const day = today.getDay()

			return day
		}

		const getTodaysOpenSec = () => {
			const day = getTodaysDay()
			//  console.log(day);

			if (day === 0 || day === 6) {
				return openingSeconds.wenOpenSec
			} else {
				return openingSeconds.wdyOpenSec
			}
		}

		const getSecondsPassedToday = () => {
			let d = new Date()
			/*
		d = d.toLocaleString("en-AU", { timeZone: "Australia/Melbourne" })
		d = new Date(d)
				*/
			return d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds()
		}

		const openSec = getTodaysOpenSec()
		const dayToday = getTodaysDay()

		const endSec = dayToday === 0 || dayToday === 6 ? openingSeconds.wenCloseSec : openingSeconds.wdyCloseSec

		//if overwride message in prismic

		const timer = setInterval(() => {
			if (countdownRef) {
				let text = document.getElementById('countdown');

				if (! text) {
					return;
				}

				const now = getSecondsPassedToday()

				const distance = endSec - now

				const hours = Math.floor(distance / 3600)
				const minutes = Math.floor((distance % 3600) / 60)

				if (message) {
					text.innerHTML = message
				} else {
					// opening
					if (isAustraliaday()) {
						text.innerHTML = 'We are open at 12pm Tomorrow.'
					} else {
						text.innerHTML =
							'We’re open for another ' +
							(hours === 0 ? '' : hours === 1 ? '1hr ' : hours + 'hrs ') +
							minutes +
							(minutes > 1 ? 'mins.' : 'min.')
					}

					if (dayToday === 1 || dayToday === 2) {
						text.innerHTML = 'We are open at 3pm on Wednesday.'
					} else if (dayToday === 5) {
						text.innerHTML = 'We are open at 12pm tomorrow.'
					}

					// if closed for the day
					if (distance < 0) {
						clearInterval(timer)

						if (isAustraliadayEve()) {
							text.innerHTML = 'We are open at 12pm Tuesday.'
						}
						// and if tomorrow is Sat or Sun
						else if (dayToday === 0 || dayToday === 1) {
							text.innerHTML = 'We are open at 3pm on Wednesday.'
						} else if (dayToday === 2 || dayToday === 3) {
							text.innerHTML = 'We are open at 3pm tomorrow.'
						} else if (dayToday === 4) {
							text.innerHTML = 'We are open at 12pm on Saturday'
						} else if (dayToday === 5 || dayToday === 6) {
							text.innerHTML = 'We are open at 12pm tomorrow.'
						} else {
							text.innerHTML = 'We are open at 3pm tomorrow.'
						}
					}

					// if before opening
					if (now < openSec) {
						const distance = openSec - now
						const hours = Math.floor(distance / 3600)
						const minutes = Math.ceil((distance % 3600) / 60)

						text.innerHTML =
							'We are open in ' +
							(hours === 0 ? '' : hours === 1 ? '1hr ' : hours + 'hrs ') +
							minutes +
							(minutes > 1 ? 'mins.' : 'min.')

						if (isAustraliaday()) {
							text.innerHTML = 'We are open at 12pm Tomorrow.'
						} else if (dayToday === 1) {
							text.innerHTML = 'We are open at 3pm on Wednesday.'
						} else if (dayToday === 3 || dayToday === 2) {
							text.innerHTML = 'We are open at 3pm tomorrow.'
						} else if (dayToday === 5) {
							text.innerHTML = 'We are open at 12pm on Saturday'
						}
					}
				}
			}
		}, 1000)

		const isAustraliaday = () => {
			let q = new Date()
			let y = q.getFullYear()
			let m = q.getMonth()
			let d = q.getDate()
	
			const todaysDate = new Date(y, m, d)
			const australiaDay = new Date('2019/03/11')
			return todaysDate.getTime() === australiaDay.getTime()
		}
	
		const isAustraliadayEve = () => {
			let q = new Date()
			let y = q.getFullYear()
			let m = q.getMonth()
			let d = q.getDate()
	
			const todaysDate = new Date(y, m, d)
			const australiaDayEve = new Date('2019/03/10')
			return todaysDate.getTime() === australiaDayEve.getTime()
		}
	})

	return (
		<ContactWrapper bg={bg}>
			<FirstHalf bg={bg}>
				<h1 id='countdown' ref={countdownRef}></h1>
			</FirstHalf>
			<SecondHalf className='grid'>
				<PeopleWrapper className='col col-12 col-xs-12'>
					{people.map((m, idx) => {
						return (
							<People className={`col col-04 col-xs-06 people-${idx}`} key={idx}>
								<PeopleInner>
									{RichText.render(m.content1)}
								</PeopleInner>
							</People>
						)
					})}
				</PeopleWrapper>
			</SecondHalf>
		</ContactWrapper>
	)
}

const ContactWrapper = styled.section`
   position: relative;
   background: url(${(props) => props.bg}) bottom center no-repeat;
   background-size: cover;
   padding: ${vars.padding.outer / 2}rem 0;
   color: ${vars.colors.blank};
   ${below.tablet`
      padding-top: ${vars.padding.inner * 3}rem;
      `}
   ${below.mobile`
      background: none;
      padding: 0;
      padding-top: ${vars.padding.inner}rem;
   `}
   ${above.mobile`
      &:after {
        content: '';
         top: 0;
         position: absolute;
         display: block;
         width: 100%;
         height: 100%;
         background: rgba(0, 0, 0, .55);
         /* z-index: -1;   */
        }
	`};
`

const FirstHalf = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: left;
	align-items: flex-end;
	z-index: 1;
	position: relative;
	margin: auto;
	max-width: calc(160rem + ${vars.padding.inner * 2}rem);
	padding-left: ${vars.padding.inner + 13.25}rem;
	padding-right: ${vars.padding.inner}rem;
	${below.giant`
				padding-left: ${vars.padding.inner}rem;;
			`} ${below.desktop`
			display:block;
		`}
  h1 {
		width: 80%;
		max-width: 900px;
		padding: 0;
		min-height: 27vh;
		${below.desktop`
			width: 100%;
		`}
		${below.mobile`
      width: 80%;
			padding-bottom: ${vars.padding.tabInner}rem;
			min-height:12vh;
    `};
	}

	${below.mobile`
      align-items: flex-start;
      flex-direction: column;
      background: url(${(props) => props.bg}) bottom center no-repeat;
      background-size: cover;
      padding: 2rem 1rem 14rem;

      h2 {
         width: 18rem;
         margin-bottom: 2rem;
      }
      .why-not {
         display: none;
      }

  `};
`

const ViewingLink = styled(Link)`
	width: 16rem;
	white-space: nowrap;
	display: block;
	background: ${vars.colors.blank};
	color: ${vars.colors.body};
	padding: 1.2rem 1.75rem;
	border-radius: 2px;
	text-decoration: none;
	margin-bottom: 1.6rem;

	.book {
		font-size: 1.5rem;
		font-weight: lighter;
		&:after {
			content: '\u2192';
			margin-left: 0.6rem;
			transition: margin-left 0.3s;
		}
	}

	&:hover > span {
		&:after {
			margin-left: 1rem;
		}
	}
`

const SecondHalf = styled.div`
	z-index: 1;
	position: relative;

	div.hours {
		padding-bottom: 1.75rem;
		padding-right: 1.75rem;
		p {
			padding: 0;
		}
	}

	${below.mobile`
      color: ${vars.colors.body};
      margin: 3rem ${vars.padding.mobInner}rem;
      border-left: 1px solid ${vars.colors.body};
      width: 90%;

      .mob-hide {
         display: none;
      }
   `};
`

const Title = styled.h3`
	margin: ${vars.padding.outer / 2}vmin 0 2rem;
	padding-bottom: 3rem;
	border-bottom: 1px solid ${vars.colors.blank};
	${below.mobile`
      font-size: 3rem;
      margin: 0;
   `};
`

const PeopleWrapper = styled.div`
	margin: ${vars.padding.outer / 2}vmin 0 0;
	padding-top: 3rem;
	border-top: 1px solid ${vars.colors.blank};
`

const People = styled.div`
	padding-right: 2rem;

	${below.tablet`
		padding-bottom:2.5rem;
	`};

	${below.mobile`
		width: 100% !important;
		padding-right: 0;
		padding-bottom: 6rem;

		&:last-child {
			padding-bottom: 0;
		}
	`}

	a {
		text-decoration: normal;
		border: none;
	}

	h1, h2, h3, h4, h5, h6, p {
		padding-bottom: 0.75em;

		&:last-child {
			padding-bottom: 0;
		}
	}

	h1 {
		font-size: 4.6rem;
	}

	h2 {
		font-size: 3.6rem;
	}

	h3 {
		font-size: 2.7rem;
	}

	h4 {
		font-size: 2.3rem;
	}

	h5 {
		font-size: 1.9rem;
	}

	h6 {
		font-size: 1.6rem;
	}

	p {
		font-size: 1.6rem;
	}

	p + h3 {
		padding-top: 1em;
	}
`

const PeopleInner = styled.div`
	max-width: 350px;
`

const PositionEtc = styled.span`
	font-size: 1.4rem;
	${below.tablet`
      font-family: ${vars.fonts.feature};
      font-size: 2rem;
      padding-top: 1rem;
  `};
`
const RightCircle = styled.img`
	width: 0;
	${below.mobile`
         width: 3rem;
   `};
`
export default Contact



// WEBPACK FOOTER //
// ./src/components/contact.js